const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CutOffQuery: any = {
    GetCutOffList: Backofficebff + '/v1/cut-off/get-cut-off-list',
    GetDistanceRanges: Backofficebff + '/v1/cargocutoff/get-distance-ranges',
    GetCountryCutOffAddressEntityTypeByRuleBFF: Backofficebff + '/v1/cargocutoff/get-country-cutOff-address-type-from-rule',
    GetAllDeliveryType: Backofficebff + '/v1/cargocutoff/get-all-delivery-type',
    GetShippingCompanyCutOffList: Backofficebff + '/v1/cargocutoff/get-shipping-company-cutOff-list',
    GetWarehousesByCountry: Backofficebff + '/v1/cargocutoff/get-warehouses-by-country',
    GetLocationDistanceMatrix: Backofficebff + '/v1/cargocutoff/get-location-distance-matrix',
};
